// This file is automatically generated. Do not edit manually.

import { InvoiceView } from "src/api/generated/erp/db/types/tables/invoiceView";
import { InvoiceUpdatingService_UpdateRequest } from "src/api/generated/erp/sales/invoicing/service/invoiceUpdatingService";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace InvoiceUpdatingApi {
	export async function getFormInitData(args: { invoiceId: number }): Promise<InvoiceView> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/getFormInitData",
			method: "POST",
			data: {
				invoiceId: args.invoiceId,
			},
		});
		return response as InvoiceView;
	}

	export async function update(args: { request: InvoiceUpdatingService_UpdateRequest }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/invoicing/update",
			method: "POST",
			data: {
				request: args.request,
			},
		});
		return response as void;
	}
}
